export default __webpack_public_path__ + "static/media/vomit.9126fb80.mp3";